interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export default function Logo({ className = '', size = 'md' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-6xl',
  }

  const beautySizeClasses = {
    sm: 'text-xs mt-0.5',
    md: 'text-sm mt-1',
    lg: 'text-base mt-1.5',
  }

  const letterSpacing = {
    sm: '0.1em',
    md: '0.15em',
    lg: '0.2em',
  }

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      {/* Guilty - Fonte serifada elegante */}
      <div 
        className={`${sizeClasses[size]} font-serif font-bold text-black leading-none`}
        style={{ 
          fontFamily: "'Playfair Display', 'Georgia', serif",
          letterSpacing: '-0.02em',
          fontWeight: 700
        }}
      >
        Guilty
      </div>
      {/* BEAUTY - Fonte sans-serif moderna, menor e centralizada */}
      <div 
        className={`${beautySizeClasses[size]} font-sans font-normal text-black uppercase`}
        style={{ 
          fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
          letterSpacing: letterSpacing[size],
          fontWeight: 400
        }}
      >
        BEAUTY
      </div>
    </div>
  )
}
